import React from 'react'
import { render } from 'react-dom'
import styled from 'styled-components'
import down_arrow from '../../../assets/svgs/down_arrow.svg'
import side_arrow from '../../../assets/svgs/side_arrow.svg'
import WalletContent from './WalletContent.js'
class WalletCollapsibleDiv extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <ParentDiv>
        <Header
          isOpen={this.props.open}
          onClick={() => {
            this.props.togglePanel(this.props.idx)
          }}>
          <HeaderText>{this.props.title} </HeaderText>
          <SideArrow isOpen={this.props.open} src={this.props.open ? down_arrow : side_arrow} />
        </Header>
        {this.props.open ? (
          <WalletContent
            route={this.props.route}
            title={this.props.title}
            onPay={values => this.props.onPay(values)}
            premium={this.props.premium}
            discount={this.props.discount}
          />
        ) : null}
      </ParentDiv>
    )
  }
}

const ParentDiv = styled.div`
  display:flex;
  flex-direction:column
  //margin: 11px 16px 11px 16px;
  margin-bottom: 24px;
  border-radius: 7px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.15);
  border: solid 1px #436ab2;
  background-color: #ffffff;
  overflow: hidden;
`

const Header = styled.div`
  display: flex;
  height: 57px;
  flex-direction: row;
  cursor: pointer;
  padding: 18px;
  background-color: ${props => (props.isOpen ? '#ebebeb' : '#ffffff')};
  color: #fff;
  font-family: Inter;
  justify-content: space-between;
`
const HeaderText = styled.div`
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.25;
  letter-spacing: 1.14px;
  text-align: left;
  color: #4a4a4a;s
`


const SideArrow = styled.img`
  max-width: 24px;
  max-height: 24px;
`
export default WalletCollapsibleDiv
